import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { UP_DEV, UP_DEV_VALUE } from 'constants/urlParams';

import { isProd } from 'helpers/utils';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: false,
            immutableCheck: false,
        }).concat(sagaMiddleware),
    devTools: !isProd(),
});

sagaMiddleware.run(rootSaga);

const urlParams = new URLSearchParams(window.location.search);
const refParams = urlParams.get(UP_DEV);

if (refParams === UP_DEV_VALUE || localStorage.getItem(UP_DEV)) {
    localStorage.setItem(UP_DEV, UP_DEV_VALUE);

    (window as any).__getState = () => store.getState();
}

export type Store = ReturnType<typeof rootReducer>;
export type Dispatch = typeof store.dispatch;
